import React from 'react';

const VARIANT = {
  active: 'success',
  pending: 'warning',
  suspended: 'danger',
  archived: 'secondary',
  queued: 'info',
  running: 'primary',
  succeeded: 'success',
  completed: 'success',
  failed: 'danger',
  idle: 'success',
  offline: 'secondary',
  assigned: 'primary',
  claiming: 'info',
  disabled: 'secondary',
};

function StatusBadge({ status, className = '' }) {
  const key = String(status || '').toLowerCase();
  const variant = VARIANT[key] || 'secondary';
  return (
    <span className={`badge text-bg-${variant} ${className}`.trim()}>
      {status || '—'}
    </span>
  );
}

export default StatusBadge;
